import type { MaybeRef, MaybeRefOrGetter, Ref } from "vue";

import { computed, toValue } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import { getEnv } from "@solvari/utils";

import useAlgolia from "@/composables/useAlgolia";

export default function (
  searchValue: Ref<string>,
  locale: MaybeRefOrGetter<LocaleMorpheus> = getEnv().config.localeCode,
  facetFilters: MaybeRef<string[]> = [
    "invisible:false",
    "is_head_product:true",
    "invisible_pro:false",
  ],
) {
  const filters = computed(() => [
    ...toValue(facetFilters),
    `locale_code: ${toValue(locale)}`,
  ]);
  return useAlgolia<{ name: string }>("product", searchValue, filters, 1000);
}
